import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#07F",
      d: "M40 20C40 8.954 31.046 0 20 0S0 8.954 0 20s8.954 20 20 20 20-8.954 20-20Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M20.89 26C14.055 26 10.16 21.504 10 14.01h3.437c.11 5.495 2.627 7.82 4.625 8.3v-8.3h3.227v4.736c1.968-.202 4.046-2.363 4.745-4.746h3.217a8.978 8.978 0 0 1-1.54 3.431 9.38 9.38 0 0 1-2.836 2.555 9.805 9.805 0 0 1 3.233 2.478A9.358 9.358 0 0 1 30 26h-3.547c-.759-2.277-2.657-4.045-5.164-4.285V26h-.4Z"
    }, null, -1)
  ]))]))
}
export default { render: render }